import Vue from 'vue'

import Axios from 'axios'

var axios = Axios.create({
  baseURL: process.env.API_URL + '/v1/api/entry',
  headers: { 'ContentType': 'application/json' }
})

var apiCommon = {
  post (apiUri, params, thisObject, successFunction) {
    axios.post(apiUri, params)
      .then((res) => {
        if (typeof successFunction === 'function') {
          successFunction(res, thisObject)
        }
      })
      .catch(() => {
        thisObject.$router.replace({name: '404'})
      })
  }
}
var api = {
  careerInfoEntry (applicationData, thisObject, successFunction) {
    apiCommon.post('/entry/careerInfoEntry', {
      'name': applicationData.name ? applicationData.name : null,
      'nameKana': applicationData.nameKana ? applicationData.nameKana : null,
      'birthDateYear': applicationData.birthDateYear ? applicationData.birthDateYear : null,
      'birthDateMonth': applicationData.birthDateMonth ? applicationData.birthDateMonth : null,
      'birthDateDay': applicationData.birthDateDay ? applicationData.birthDateDay : null,
      'sexFlg': applicationData.sexFlg ? applicationData.sexFlg : null,
      'prefId': applicationData.prefId ? applicationData.prefId : null,
      'telCellular': applicationData.telCellular ? applicationData.telCellular : null,
      'email': applicationData.email ? applicationData.email : null,
      'scienceId': applicationData.science ? applicationData.science : null,
      'schlcrKbn': applicationData.schlcrKbn ? applicationData.schlcrKbn : null,
      'schlName': applicationData.schlName ? applicationData.schlName : null,
      'schlDeptName': applicationData.schlDeptName ? applicationData.schlDeptName : null,
      'gradyr': applicationData.gradyr ? applicationData.gradyr : null
    }, thisObject, successFunction)
  }
}

Vue.use({
  install (Vue, options) {
    Vue.prototype['$api'] = api
  }
})

export default api
